export default {
    clickToCopy: 'Copy Signup Link',
    fifthListImportInvoices:
        'Export Invoice, accounting, and payment data (CSV)',
    findOutMoreLink:
        'Find out more <0>here</0> about the product and arrange a demonstration or trial.',
    firstListElementStarterPlan:
        'Use a limited set of MakeLeaps features free of charge',
    firstListImportInvoices: 'View a list of your Invoices',
    forRicohTradeAutomationUsers: 'For RICOH Trade Automation users',
    fourthListImportInvoices: 'Input bookkeeping information for your Invoices',
    goButton: 'Go to the App',
    inviteParagraph:
        "You can invite vendors who don't have a MakeLeaps account to our Starter Plan. Invite them by sending a special signup link, which can be copied from the following button.",
    listImportInvoicesTitle:
        'Import the invoices from your MakeLeaps Secure Inbox to Trade Automation and do the following:',
    listStarterPlanTitle: "What's special about the Starter plan",
    logInToRicohTradeAutomation: 'Log in to RICOH Trade Automation',
    paragraphThinkingAboutRicohTradeAutomation:
        'With RICOH Trade Automation (sold separately), you connect to MakeLeaps and can digitize purchasing, invoice processing, and the workflow between you and your vendors.',
    secondListElementStarterPlan:
        'Issue documents such as Order Confirmation and Invoice',
    secondListImportInvoices: 'View Invoice details',
    signPageForVendors: 'Sign-up page for your vendors',
    subtitle:
        'Import MakeLeaps invoices, associate them automatically to orders, and output bookkeeping/payment data.',
    thirdListElementStarterPlan: 'Combine Invoices',
    thirdListImportInvoices:
        'Automatically link Invoices to Orders you sent via MakeLeaps',
    title: 'RICOH Trade Automation',
    titleThinkingAboutRicohTradeAutomation:
        'For those thinking about RICOH Trade Automation',
};
